import React, { useState } from 'react';
import TableDadosContrato from '../TableDadosContrato';
import { useGlobal } from '../../../contexts/Global/context';
import * as S from '../styles';

const ConsultarPlanosValores = () => {
    const { dataActiveContract } = useGlobal();

    const [activeTab, setActiveTab] = useState('1');

    return (
        <>
            <S.StyledTabs activeKey={activeTab} onChange={setActiveTab} defaultActiveKey="1" style={{ margin: '32px' }}>
                <S.StyledTabPane tab={`Vigência ${dataActiveContract.dataUltimaVigencia}`} key="1">
                    <TableDadosContrato beneficiarySituation="Inativo" />
                </S.StyledTabPane>
            </S.StyledTabs>
        </>
    );
};

export default ConsultarPlanosValores;
